export class ChangeDashboardId {
   public static readonly type = '[Dashboard Viewer] Change Dashboard Id';

   constructor(public brickInstanceId: string, public dashboardId: number) {}
}

export class ChangeAgentId {
   public static readonly type = '[Dashboard Viewer] Change Agent Id';

   constructor(public brickInstanceId: string, public agentId: number) {}
}

export class ChangeUseBrowserTimezoneAsTargetTimezone {
   public static readonly type = '[Dashboard Viewer] Change Use Browser Timezone as Target Timezone';

   constructor(public brickInstanceId: string, public useBrowserTimezoneAsTargetTimezone: boolean) {}
}
